import { themeStore } from "stores/themes";
import { partition } from "lodash";

export const fetchFavourites = async () => {
  if (typeof App === 'undefined' || !App.order.logged_in()) return false;

  await themeStore.some();
  const [favourited] = partition(themeStore.themes, 'favourite');

  return favourited;
}